import Root from "pages/Root";
import { createHashRouter as createRouter } from "react-router-dom";
import { RouteObjectWithLabel } from "types";
import GamesContainer from "components/GamesContainer";
import NotFound from "components/NotFound";
import Home from "pages/Home";

export const routes: RouteObjectWithLabel[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/games/:game",
    element: <GamesContainer />,
  },
];

const router = createRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <NotFound />,
    children: routes,
  },
]);

export default router;
